import { FontsEnum } from 'core/constants/enums/FontsEnum.ts';

export const oneTimePurchaseComponentStyles = {
	creditsSection: {
		width: '100%',
		padding: '24px',

		backgroundColor: 'colors.dark6',

		display: 'flex',
		flexDirection: 'column',
		alignItems: 'start',
		gap: '32px',

		'& svg': { height: '24px', width: 'auto' },
	},
	titleContainer: {
		width: '60%',
		justifyContent: 'center',
	},
	title: {
		color: 'colors.light2',
		size: '48px',
		width: '100%',
		fontFamily: FontsEnum.INTER,
	},
	offerTitle: {
		color: 'colors.light3',
	},
	offerContainer: {
		margin: '24px 0 48px',

		backgroundColor: 'colors.systemYellow',
		padding: '8px',
		borderRadius: '8px',
	},
	offerText: {
		color: 'colors.dark4',
		textAlign: 'left',
	},
	creditValueTitle: {
		color: 'colors.light4',
		margin: '28px 0 16px 0',
	},
};
